<template>

  <div>

    <p class="font-medium text-14 text-onyx mb-8px">{{ filter.label }}</p>

    <div class="relative w-full" ref="filterNotDropdown" v-for="(item, index) in filter.value" :key="index">

      <vs-radio
          color="primary"
          v-model="selected"
          :vs-value="(item.id || item.option).toString()"
          v-if="isRadioOption(filter)"
          @input="submitSearch(200)"
          class="custom-checkbox">
        {{ item.option }}
      </vs-radio>
      
      <div v-else-if="isRadioToggleOption(filter)" class="custom-checkbox space-x-2 toggle-radio"> 
        <input type="radio" class="cursor-pointer" name="radio" v-model="selected" :value="item.id.toString()" :id="item.id" @click="toggleRadio( item.id.toString() )">
        
        <label :for="item.id" class="text-onyx-light cursor-pointer text-14" >
          {{ item.option }} 
        </label>
      </div>

      <vs-checkbox
          v-else-if="isAllSelector((item.id || item.option).toString())"
          :disabled="checkboxDisabled(item.id || item.option)"
          color="primary"
          v-model="selectAll"
          :vs-value="(item.id || item.option).toString()"
          @input="submitMultipleSearch(1000)"
          icon="icon-check"
          icon-pack="feather"
          class="custom-checkbox">
        {{ item.option }}
      </vs-checkbox>

      <vs-checkbox
          v-else
          :disabled="checkboxDisabled(item.id || item.option)"
          color="primary"
          v-model="selected"
          :vs-value="(item.id || item.option).toString()"
          @input="submitMultipleSearch(1000)"
          icon="icon-check"
          icon-pack="feather"
          class="custom-checkbox">
        {{ item.option }}
      </vs-checkbox>

    </div>

  </div>

</template>

<script>

export default {
  name: "FilterCheckBoxInput",

  props: {
    filter:{
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectOptions: this.filter.value,
      checkBoxInterval: null,
      radioModel: ''
    }
  },

  computed: {
    selected : {
      get(){
        return this.filter.selected;
      },
      set( value ) {
        this.setSelectedValue(value);
      }
    },
    selectAll: {
      get: function () {
        return (this.selectOptions && (this.selectOptions.length > 1)) ?
            (this.selected && (this.selected.length === this.selectOptions.length - 1 || this.selected.includes("0"))) :
            false;
      },
      set: function (value) {
        if (!this.selectAll) {
          this.selectAllOptions();
        } else {
          this.selected = [];
        }
      }
    }
  },

  created() {
    if (this.isRadioOption) {
      this.radioModel = this.filter.initValue || '';
      if(this.radioModel.length > 1){
        this.setSelectedValue('');
      }
    }else {
      if (this.filter.initValue === '0') {
        this.selectAllOptions();
      }
      else {
        this.selected = [...(this.filter.initValue  || [])]
      }
    }
  },

  methods: {
    checkboxDisabled(itemId) {
      if(this.filter.selected && this.filter.selected.length > 0 && this.filter.selectType === 'single') {
        return (this.filter.value.length - this.filter.selected.length === 1) 
          ? this.filter.selected.includes(itemId) // option all selected, disable the rest
          : !this.filter.selected.includes(itemId)
      }else {
        return false;
      }
    },

    selectAllOptions() {
      let selected = [];
      this.selectOptions.forEach(opt => {
        if (!this.isAllSelector(opt.id || opt.option)) {
          selected.push(opt.id.toString() || opt.option);
        }
      });
      this.selected = [...selected];
    },

    setSelectedValue(value) {
      this.$emit("selectedCheckOption", this.filter.name, value);
    },
    isAllSelector(option) {
      return option === '0';
    },
    isRadioOption(filter) {
      return filter.type === 'radio' && !filter.toggleRadio
    },
    isRadioToggleOption(filter) {
      return filter.type === 'radio' && filter.toggleRadio
    },
    submitSearch(time) {
      setTimeout( () =>{
        this.$emit('submitFilters');
      }, time);
    },
    submitMultipleSearch(time) {
      if (this.checkBoxInterval) clearInterval(this.checkBoxInterval);
      this.checkBoxInterval = setInterval(() => {
        clearInterval(this.checkBoxInterval);
        this.$emit('submitFilters');
      }, time);
    },
    toggleRadio(value) {
      if (this.filter.selected.includes(value)) {
        this.setSelectedValue('');
      }

      this.submitSearch(200);
    },
  }
}
</script>

<style lang="scss">
.custom-checkbox {
  height: 42px;
  display: flex;
  align-items: center;
  margin-left: 0 !important;

  & .con-slot-label {
    margin-top: 0;
  }
}

.toggle-radio {
  & input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgb(180, 180, 180);
    transition: 0.1s all linear;
  }

  & input:checked {
    background-color: var(--primary);
    border-color: var(--primary);
  }
}
</style>